module.exports = __webpack_public_path__ + "media/img/specialize/item14-1c570ede720c6bf6f1e4d1402cc2feab.svg";